<template>
  <div class="content-wrap">
    <template>
      <a-form-model
        layout="inline"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        class="customer-list-form"
        :colon="false"
      >
        <a-form-model-item :label="$t('driverList.driverName')">
          <a-auto-complete
            v-model.trim="params.condition.name"
            :placeholder="$t('driverList.driverName')"
            size="small"
            :allowClear="true"
            :data-source="dataSourceName"
            @change="onChangeName"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('businessDispatch.contactNumber')">
          <a-auto-complete
            v-model.trim="params.condition.mobile"
            :placeholder="$t('businessDispatch.contactNumber')"
            size="small"
            :allowClear="true"
            :data-source="dataSourceMobile"
            @change="onChangeMobile"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('driverList.IDCard')">
          <a-auto-complete
            v-model.trim="params.condition.idCardNumber"
            :placeholder="$t('driverList.IDCard')"
            size="small"
            :allowClear="true"
            :data-source="dataSourceIdCardNumber"
            @change="onChangeIdCardNumber"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            type="primary"
            @click="search"
            size="small"
            style="marginleft: 10px"
          >
            {{ $t('search') }}
          </a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="resetSearch" size="small"> {{ $t('reset') }} </a-button>
        </a-form-model-item>
      </a-form-model>
    </template>
    <a-modal
      :title="isAdd ? $t('driverList.addDriverInfo') : $t('driverList.updateDriverInfo')"
      :visible="visible_driverform"
      @cancel="canceldriverform"
    >
      <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
        <a-form-item :label="$t('driverList.driverName')">
          <a-input
            allowClear
            v-model.trim="addDriverreq.name"
            style="width: 200px"
            :placeholder="$t('driverList.driverName')"
            v-decorator="[
              'note',
              {
                rules: [{ required: true, message: $t('driverList.driverName') }],
              },
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('businessDispatch.phoneNumber')">
          <a-input
            allowClear
            v-model.trim="addDriverreq.mobile"
            style="width: 200px"
            :placeholder="$t('businessDispatch.phoneNumber')"
            v-decorator="[
              'note',
              {
                rules: [{ required: true, message: $t('businessDispatch.phoneNumber') }],
              },
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('driverList.IDCard')">
          <a-input
            allowClear
            v-model.trim="addDriverreq.idCardNumber"
            style="width: 200px"
            :placeholder="$t('driverList.IDCard')"
            v-decorator="[
              'note',
              {
                rules: [{ required: true, message: $t('driverList.IDCard') }],
              },
            ]"
          >
          </a-input>
        </a-form-item>
      </a-form>
      <template slot="footer" v-if="isAdd">
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading_driver"
          @click="okdriver"
        >
          {{ $t('sure') }}
        </a-button>
        <a-button key="back" @click="resetdriver">{{ $t('reset') }}</a-button>
      </template>
      <template slot="footer" v-if="!isAdd">
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading_driver"
          @click="okdriver"
        >
          {{ $t('update') }}
        </a-button>
        <a-button key="back" @click="resetdriver">{{ $t('reset') }}</a-button>
      </template>
    </a-modal>

    <div class="table-area">
      <!-- table展示 -->
      <table-fixed
        :tableData="tableData"
        :tableColumn="columns"
        :columnSettingsKey="$route.name"
        :pagination="pagination"
        :loading="loading"
      >
        <template v-slot:toolbar>
          <a-button type="primary" size="small" @click="showBox">
            {{ $t('driverList.addDriverInfo') }}
          </a-button>
        </template>
        <template v-slot:option="scope">
          <a-button @click="showUpdate(scope.driver)">{{ $t('edit') }}</a-button>
        </template>
      </table-fixed>
    </div>
  </div>
</template>
<script>
import tableFixed from "../../components/table-fixed.vue";
import { driverlist, addDriver, updateDriver } from "../../api/basicData";
import { columns } from "./driver-list";
import { searchReqParam } from "../../utils/searchReqParam";
import { checkIdCard } from '../../utils/regs'

export default {
  name: "business-dispatch",
  components: { tableFixed },
  data() {
    return {
      columns,
      req: searchReqParam(),
      tableData: [],
      params: {
        condition: {
          companyId: "",
          idCardNumber: "",
          mobile: "",
          name: "",
        },
        page: 1,
        pageSize: 10,
      },
      pagination: {
        showSizeChanger: true,
        defaultPageSize: 10,
        pageSizeOptions: ["10", "15", "50", "100"],
        total: 0,
        current: 1,
        showTotal: (total) => this.$t('totalText', { total }),
        onChange: (page) => {
          this.pagination.current = page;
          this.req.params.page = page;
          this.pageInit();
        },
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1;
          this.req.params.page = 1;
          this.req.params.pageSize = pageSize;
          this.pageInit();
        },
      },
      loading: false,
      visible_driverform: false,
      confirmLoading_driver: false,
      addDriverreq: {
        companyId: "",
        currentUserId: "",
        idCardNumber: undefined,
        mobile: undefined,
        name: undefined,
      },
      isAdd: false,
      initDriverreq: {},
      dataSourceName: [],
      dataSourceMobile: [],
      dataSourceIdCardNumber: [],
    };
  },
  created() {},
  mounted() {
    this.pageInit();
  },
  methods: {
    pageInit() {
      this.req.params = this.params;
      this.loading = true;
      driverlist(this.req).then((res) => {
        let resData = JSON.parse(res.data);
        if (!resData.success || resData.code != "0") {
          this.$message.error(resData.msg);
          return;
        }
        this.tableData = resData.data.list;
        this.pagination.total = resData.data.total;
        this.loading = false;
      });
    },
    // 搜索
    search() {
      this.pagination.onChange(1);
    },
    // 重置
    resetSearch() {
      this.params.condition = {};
    },
    showBox() {
      this.isAdd = true;
      // 新增时的初始化数据
      this.initDriverreq = {
        companyId: "",
        currentUserId: "",
        idCardNumber: undefined,
        mobile: undefined,
        name: undefined,
      };
      this.addDriverreq = {
        companyId: "",
        currentUserId: "",
        idCardNumber: undefined,
        mobile: undefined,
        name: undefined,
      };
      this.visible_driverform = true;
    },
    canceldriverform() {
      this.visible_driverform = false;
      this.confirmLoading_driver = false;
    },
    resetdriver() {
      // 重置表单的数据为初始化数据 -- 两个不同的对象，数据独立
      this.addDriverreq = {
        ...this.initDriverreq,
      };
    },
    okdriver() {
      // name
      // const regPhone = /^1(3|4|5|6|7|8)\d{9}$/
      // const regIdCard = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
      if (this.addDriverreq.name == "" || this.addDriverreq.name == undefined) {
        this.$message.error(this.$t('driverList.nameCannotBeEmpty'));
        return;
      }
      if (!this.addDriverreq.mobile) {
        this.$message.error(this.$t('driverList.pleaseEnterCorrectPhoneNumber'));
        return;
      }
      // if (!regPhone.test(this.addDriverreq.mobile) ) {
      //   this.$message.error(this.$t('driverList.pleaseEnterCorrectPhoneNumber'));
      //   return;
      // }
      if (!checkIdCard(this.addDriverreq.idCardNumber) ) {
        this.$message.error(this.$t('driverList.pleaseEnterCorrectIDCard'));
        return;
      }
      this.req.params = this.addDriverreq;
      // console.log(this.req);
      // 新增
      if (this.isAdd) {
        addDriver(this.req).then((res) => {
					console.log(res.data);
					let result = JSON.parse(res.data);
					if (result.success && result.code == "0") {
						// 成功提示信息
						this.$message.success(result.msg);
						// 关闭新增窗口
						this.visible_driverform = false;
						// 重置新增参数 -- 参数重置现在放到了入口
						// this.resetdriver();
						// 刷新列表数据
						this.pageInit();
					} else if (result.code == "201") {
						this.$message.error(this.$t('driverList.alreadyRegisteredPhoneNumber'));
					} else if (result.code == "dat-ID_CARD_EXISTS") {
						this.$message.error(result.msg);
					}  else if (result.msg) {
						this.$message.error(result.msg);
					} else {
						this.$message.error(this.$t('driverList.checkDriverAlreadyExists'));
					}
				});
				return;
      }
      // 更新
      updateDriver(this.req).then((res) => {
        console.log(res.data);
        let result = JSON.parse(res.data);
        if (!result.success || result.code != 0) {
          this.$message.error(result.msg);
          return;
        }
        if (result.success && result.code == "0") {
          // 成功提示信息
          this.$message.success(result.msg);
          // 关闭新增窗口
          this.visible_driverform = false;
          // 重置新增参数 -- 参数重置现在放到了入口
          // this.resetdriver();
          // 刷新列表数据
          this.pageInit();
        } else if (result.code == "201") {
          this.$message.error(this.$t('driverList.alreadyRegisteredPhoneNumber'));
        } else if (result.code == "dat-ID_CARD_EXISTS") {
          this.$message.error(result.msg);
        } else {
          this.$message.error(this.$t('driverList.checkDriverAlreadyExists'));
        }
      });
    },
    // 打开更新窗口
    showUpdate(driver) {
      console.log(driver);
      this.isAdd = false;
      this.initDriverreq = {
        companyId: driver.companyId,
        currentUserId: "",
        id: driver.id,
        idCardNumber: driver.idCardNumber,
        mobile: driver.mobile,
        name: driver.name,
      };
      this.addDriverreq = {
        companyId: driver.companyId,
        currentUserId: "",
        id: driver.id,
        idCardNumber: driver.idCardNumber,
        mobile: driver.mobile,
        name: driver.name,
      };
      this.visible_driverform = true;
    },
    // 司机姓名
    onChangeName(searchText) {
      driverlist(this.req).then((res) => {
        let temp = JSON.parse(res.data).data.list;
        this.dataSourceName = [];
        temp.forEach((item) => {
          if (this.dataSourceName.indexOf(item.name) == -1) {
            this.dataSourceName.push(item.name);
          }
        });
      });
      this.dataSourceName = !searchText ? [] : this.dataSourceName;
    },
    // 类型电话
    onChangeMobile(searchText) {
      driverlist(this.req).then((res) => {
        let temp = JSON.parse(res.data).data.list;
        this.dataSourceMobile = [];
        temp.forEach((item) => {
          if (this.dataSourceMobile.indexOf(item.mobile) == -1) {
            this.dataSourceMobile.push(item.mobile);
          }
        });
      });
      this.dataSourceMobile = !searchText ? [] : this.dataSourceMobile;
    },

    // 身份证号
    onChangeIdCardNumber(searchText) {
      driverlist(this.req).then((res) => {
        let temp = JSON.parse(res.data).data.list;
        this.dataSourceIdCardNumber = [];
        temp.forEach((item) => {
          if (this.dataSourceIdCardNumber.indexOf(item.idCardNumber) == -1) {
            this.dataSourceIdCardNumber.push(item.idCardNumber);
          }
        });
      });
      this.dataSourceIdCardNumber = !searchText
        ? []
        : this.dataSourceIdCardNumber;
    },
  },
};
</script>

<style lang="less" scoped></style>
